import styles from './timeline.module.scss';

import classNames from 'classnames';
import { ReactNode, isValidElement } from 'react';

type TimelineItemProps = {
  type?: 'default' | 'info' | 'success' | 'warning' | 'danger';
  dotWrapperClassName?: string;
  customDot?: ReactNode;
  content: ReactNode;
  className?: string;
};

export const Timeline = ({
  items,
  includeLastItemLine = false,
}: {
  items: TimelineItemProps[];
  includeLastItemLine?: boolean;
}) => {
  return (
    <div
      className={classNames(styles.timeline, {
        [styles.includeLastItemLine]: includeLastItemLine,
      })}
    >
      {items.map((item, index) => (
        <TimelineItem key={`timeline-item-${index}`} {...item} />
      ))}
    </div>
  );
};

const TimelineItem = ({ type = 'default', dotWrapperClassName, customDot, content, className }: TimelineItemProps) => {
  return (
    <>
      <div className={`${styles.timelineItem} ${className}`}>
        <div className={classNames(styles.lineWrapper, dotWrapperClassName)}>
          {!!customDot && isValidElement(customDot) ? (
            <>{customDot}</>
          ) : (
            <div
              className={classNames(styles.dotStatus, {
                'bg-grey-400': type === 'default',
                'bg-blue-gray-500': type === 'info',
                'bg-success-500': type === 'success',
                'bg-warning-300': type === 'warning',
                'bg-error-500': type === 'danger',
              })}
            ></div>
          )}
        </div>

        <div className={styles.itemContent}>{content}</div>
      </div>
    </>
  );
};
